import React, { useEffect } from 'react';
import { Badge, Stack, ToggleButton, ToggleButtonGroup, Tooltip, useTheme } from '@mui/material';
import { css } from '@emotion/css';
import { Palette } from '@mui/icons-material';
import { range } from '../../math/_common';
const PigmentIcon = ({ pigment }) => {
    const theme = useTheme();
    const backgroundColor = typeof pigment.color === 'string'
        ? pigment.color
        : `rgb(${pigment.color[0]},${pigment.color[1]},${pigment.color[2]})`;
    return React.createElement("span", { className: css({
            backgroundColor,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: '2px',
            width: '27.42px',
            height: '27.42px',
        }) });
};
const normalize = (n) => (n === 0) ? 0 : (n > 0) ? 1 : -1;
const modulo = (n, base) => ((n % base) + base) % base;
export const PALETTE_PANE_ID = 'hexmapeditor-palette-pane';
export const PalettePane = ({ pigment, pigments, setPigment }) => {
    const theme = useTheme();
    // Palette Hotkeys and Scroll Shortcuts
    useEffect(() => {
        const numberKeys = range(pigments.length).map(i => `${i + 1}`);
        const keydownHandler = (e) => numberKeys.includes(e.key) && e.metaKey && setPigment(pigments[Number(e.key) - 1]);
        window.addEventListener('keydown', keydownHandler);
        return () => window.removeEventListener('keydown', keydownHandler);
    }, [pigments]);
    return (React.createElement(Stack, { alignItems: "center" },
        React.createElement(Tooltip, { title: "Palette", arrow: true, placement: "left", enterDelay: 500, enterTouchDelay: 500 },
            React.createElement(Palette, { sx: { cursor: 'help', padding: '0.25em' } })),
        React.createElement(ToggleButtonGroup, { value: pigment, orientation: "vertical", exclusive: true, onChange: (_, value) => setPigment(value), sx: { backgroundColor: theme.palette.background.paper, padding: '0.25em' } }, pigments.map((pigment, idx) => (React.createElement(Tooltip, { title: pigment.name, arrow: true, placement: "left", enterDelay: 500, enterTouchDelay: 500 },
            React.createElement(ToggleButton, { key: pigment.name, value: pigment, "aria-label": pigment.name, sx: { border: 'none' } },
                React.createElement(Badge, { anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, badgeContent: idx + 1, overlap: 'rectangular', color: 'primary' },
                    React.createElement(PigmentIcon, { pigment: pigment })))))))));
};
//# sourceMappingURL=PalettePane.js.map